import { render, staticRenderFns } from "./CustomerRecord.vue?vue&type=template&id=1742b40b&"
import script from "./CustomerRecord.vue?vue&type=script&lang=js&"
export * from "./CustomerRecord.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRecord.vue?vue&type=style&index=0&id=1742b40b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports